import { faBriefcase, faBuilding, faCheckCircle, faChild, faClipboard, faFile, faGlobe, faGraduationCap, faHeart, faPlane, faStar, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const ServicesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const serviceCategories = [
    { id: 'all', label: 'All Services', icon: faStar },
    { id: 'student', label: 'Student Visas', icon: faGraduationCap },
    { id: 'work', label: 'Work Visas', icon: faBriefcase },
    { id: 'family', label: 'Family Visas', icon: faUsers },
    { id: 'business', label: 'Business Visas', icon: faBuilding },
    { id: 'visit', label: 'Visit Visas', icon: faPlane }
  ];

  const allServices = [
    {
      id: 1,
      category: 'student',
      icon: faGraduationCap,
      title: 'Student Visa (Tier 4)',
      description: 'Complete support for international students pursuing education in the UK',
      price: 'From £499',
      duration: '3-8 weeks',
      features: [
        'CAS Application Support',
        'Financial Document Preparation',
        'University Liaison',
        'Interview Preparation',
        'Post-Approval Support'
      ],
      eligibility: 'Offer from licensed UK institution, Financial requirements, English language proof',
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    },
    {
      id: 2,
      category: 'work',
      icon: faBriefcase,
      title: 'Skilled Worker Visa',
      description: 'Professional visa solutions for skilled professionals with UK job offers',
      price: 'From £799',
      duration: '3-6 weeks',
      features: [
        'Sponsorship Certificate Support',
        'Salary Threshold Assessment',
        'Document Verification',
        'Priority Processing',
        'Dependent Visa Support'
      ],
      eligibility: 'Job offer from licensed sponsor, Appropriate salary, English language skills',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      id: 3,
      category: 'family',
      icon: faHeart,
      title: 'Spouse & Partner Visa',
      description: 'Family reunion services for spouses, partners, and family members',
      price: 'From £899',
      duration: '2-12 weeks',
      features: [
        'Relationship Evidence Preparation',
        'Financial Requirement Assessment',
        'Accommodation Verification',
        'English Language Support',
        'Appeal Assistance'
      ],
      eligibility: 'Genuine relationship, Financial requirements, Adequate accommodation',
      image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      id: 4,
      category: 'business',
      icon: faBuilding,
      title: 'Business & Investor Visas',
      description: 'Entrepreneur and investor visa solutions for business professionals',
      price: 'From £1,299',
      duration: '4-12 weeks',
      features: [
        'Business Plan Preparation',
        'Investment Verification',
        'Market Research Support',
        'Legal Compliance Guidance',
        'Ongoing Business Support'
      ],
      eligibility: 'Investment funds, Business experience, Viable business plan',
      image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      id: 5,
      category: 'visit',
      icon: faPlane,
      title: 'Standard Visitor Visa',
      description: 'Tourist, business visitor, and short-term study visa services',
      price: 'From £299',
      duration: '1-3 weeks',
      features: [
        'Travel Itinerary Planning',
        'Financial Evidence Preparation',
        'Accommodation Booking Support',
        'Purpose of Visit Documentation',
        'Fast-track Processing'
      ],
      eligibility: 'Genuine visitor intent, Sufficient funds, Return travel arrangements',
      image: 'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      id: 6,
      category: 'student',
      icon: faChild,
      title: 'Child Student Visa',
      description: 'Specialized visa services for students under 18 studying in the UK',
      price: 'From £599',
      duration: '3-8 weeks',
      features: [
        'Parental Consent Documentation',
        'Guardianship Arrangements',
        'School Placement Support',
        'Welfare Requirements',
        'Parent Visa Assistance'
      ],
      eligibility: 'Place at independent school, Parental consent, Care arrangements',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      id: 7,
      category: 'work',
      icon: faGlobe,
      title: 'Global Talent Visa',
      description: 'Exceptional talent visa for leaders in academia, research, arts, and technology',
      price: 'From £1,499',
      duration: '4-8 weeks',
      features: [
        'Endorsement Application',
        'Portfolio Preparation',
        'Expert Reference Coordination',
        'Fast-track Processing',
        'Settlement Pathway Guidance'
      ],
      eligibility: 'Exceptional talent, Endorsement from approved body, Industry recognition',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
   
  ];

  const filteredServices = activeCategory === 'all' 
    ? allServices 
    : allServices.filter(service => service.category === activeCategory);

  // const stats = [
  //   { number: '98%', label: 'Success Rate' },
  //   { number: '10K+', label: 'Applications' },
  //   { number: '24/7', label: 'Support' },
  //   { number: '50+', label: 'Countries' }
  // ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      {/* Header Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center" data-aos="zoom-in">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-cyan-300 rounded-full mr-2 animate-pulse"></span>
              OUR SERVICES
            </div>
            <h1 className="text-5xl font-bold mb-6">UK , European  Visa & Immigration Services</h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Comprehensive visa solutions tailored to your unique circumstances. 
              From student visas to settlement applications, we guide you every step of the way.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
    

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Category Filter */}
        <div className="mb-12"  data-aos='fade-down'>
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Browse by Category</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {serviceCategories.map((category) => (
              <button 
             
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
                  activeCategory === category.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 border border-gray-200'
                }`}
              >
                <span className="mr-2 text-lg"><FontAwesomeIcon icon={category.icon}/></span>
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {filteredServices.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" data-aos="zoom-out">
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg">
                  <span className="text-2xl"><FontAwesomeIcon icon={service.icon}/></span>
                </div>
                
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                
                {/* Duration */}
                <div className="flex items-center text-sm text-gray-500 mb-4">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  Processing: {service.duration}
                </div>

                {/* Features */}
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">What's Included:</h4>
                  <ul className="space-y-1">
                    {service.features.slice(0, 3).map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-600">
                        <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Eligibility */}
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Basic Eligibility:</h4>
                  <p className="text-sm text-gray-600 line-clamp-2">{service.eligibility}</p>
                </div>

                {/* CTA Button */}
                <button className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
                  Get  Assessment
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Process Overview */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-8 text-white mb-16" data-aos='fade-right'>
          <h2 className="text-3xl font-bold text-center mb-8">How Our Service Works</h2>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faFile}/></span>
              </div>
              <h3 className="font-bold mb-2"> Assessment</h3>
              <p className="text-blue-100 text-sm">Complete our quick online assessment</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faClipboard}/></span>
              </div>
              <h3 className="font-bold mb-2">Document Preparation</h3>
              <p className="text-blue-100 text-sm">We prepare all required documents</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faPlane}/></span>
              </div>
              <h3 className="font-bold mb-2">Application Submission</h3>
              <p className="text-blue-100 text-sm">We handle the entire submission process</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faCheckCircle}/></span>
              </div>
              <h3 className="font-bold mb-2">Visa Approval</h3>
              <p className="text-blue-100 text-sm">Receive your visa with our support</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto" data-aos='fade-left'>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Not Sure Which Service You Need?</h2>
            <p className="text-gray-600 mb-6">
              Take our 2-minute assessment and get personalized visa recommendations
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
                Take  Assessment
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;